import { useCallback, useEffect, useRef, useState } from 'react'

type UseCountdownOptions = {
  autoStart?: boolean
}

export const useCountdown = (initialSeconds: number, options?: UseCountdownOptions) => {
  const { autoStart = false } = options || {}

  const [timeLeft, setTimeLeft] = useState(initialSeconds)
  const [isRunning, setIsRunning] = useState(false)
  const [isFinished, setIsFinished] = useState(false)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const clearTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }

  const start = useCallback(() => {
    if (intervalRef.current || timeLeft <= 0) return

    setIsRunning(true)
    setIsFinished(false)

    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearTimer()
          setIsRunning(false)
          setIsFinished(true)
          return 0
        }
        return prev - 1
      })
    }, 1000)
  }, []) // ✅ KHÔNG phụ thuộc timeLeft

  const stop = useCallback(() => {
    clearTimer()
    setIsRunning(false)
  }, [])

  const reset = useCallback(() => {
    clearTimer()
    setTimeLeft(initialSeconds)
    setIsFinished(false)
    setIsRunning(false)

    if (autoStart) {
      setTimeout(() => start(), 0) // ✅ Delay nhỏ để đảm bảo state được cập nhật
    }
  }, [initialSeconds, autoStart, start])

  useEffect(() => {
    if (autoStart) {
      start()
    }

    return () => {
      clearTimer()
    }
  }, [autoStart, start])

  return {
    timeLeft,
    isRunning,
    isFinished,
    start,
    stop,
    reset,
  }
}
